import { Columns } from "@fullscript/aviary-web";

import { Skeleton, Spacer } from "@aviary";
import { SkeletonProductCard } from "@shared/components/SkeletonProductCards/SkeletonProductCard/SkeletonProductCard";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

const SkeletonSimilarProducts = () => {
  const { desktop } = useBreakpoints();

  const renderProductCardsSkeleton = () => {
    return (
      <Columns>
        {Array.from({ length: 4 }).map((_, i) => (
          <SkeletonProductCard gridColumnWidth={desktop.greaterThan ? 3 : 6} key={i} />
        ))}
      </Columns>
    );
  };

  return (
    <>
      <Skeleton type="typography" typographySize="h2" />
      <Spacer />
      {renderProductCardsSkeleton()}
    </>
  );
};

export { SkeletonSimilarProducts };
